import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BellRinging02 = function BellRinging02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14.0003 21h-4M2.2941 5.8199C2.2798 4.3685 3.0623 3.0133 4.3264 2.3m17.3761 3.5199c.0144-1.4513-.7681-2.8066-2.0322-3.5199m-1.67 5.7a5.9997 5.9997 0 0 0-6-6 6 6 0 0 0-6 6c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5948 17 4.1929 17 5.389 17h13.2223c1.1963 0 1.7944 0 1.9271-.0984.1469-.109.1856-.1785.2005-.3608.0134-.1647-.3538-.7549-1.0884-1.9354-.8708-1.3994-1.6503-3.5152-1.6503-6.6054"
    })
  }));
};
export default BellRinging02;